import type { DisabilityCategory, NonResidentReason, SpouseIneligibilityReason, YesNo } from './spouseSectionTypes';
import { formatIncomeYen, parseIncomeYen } from './spouseEligibility';
import { changeReasonLabelKey, isSpouseChangeReasonCode } from './spouseChangeReason';

export function formatYesNo(t: (k: string) => string, v: YesNo | ''): string {
  if (v === 'yes') return t('submitDocuments.dependentDeduction.spouse.yes');
  if (v === 'no') return t('submitDocuments.dependentDeduction.spouse.no');
  return '—';
}

export function formatDobDisplay(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso || '—';
  return `${m[1]}/${m[2]}/${m[3]}`;
}

export function formatIncomeDisplay(raw: string): string {
  const n = parseIncomeYen(raw);
  if (!raw.trim()) return '—';
  return `¥${formatIncomeYen(n)}`;
}

export function disabilityLabel(t: (k: string) => string, v: DisabilityCategory | ''): string {
  if (!v) return '—';
  return t(`submitDocuments.profileName.disabilityCategory.option.${v}`);
}

export function nonResidentReasonLabel(t: (k: string) => string, v: NonResidentReason | ''): string {
  if (!v) return '—';
  return t(`submitDocuments.familyInfo.nonResident.${v}`);
}

export function ineligibilityMessageKey(reason: SpouseIneligibilityReason): string {
  return `submitDocuments.dependentDeduction.spouse.ineligible.${reason}`;
}

export function formatChangeReasonDisplay(t: (k: string) => string, stored: string): string {
  const v = stored.trim();
  if (!v) return '—';
  if (isSpouseChangeReasonCode(v)) {
    return t(changeReasonLabelKey(v));
  }
  return v;
}

export function isChangeReasonOtherStored(stored: string): boolean {
  const v = stored.trim();
  return v.length > 0 && !isSpouseChangeReasonCode(v);
}
